import axios from 'axios'
import store from './../store';

export default class CommissionService {




    async listCommissions(num,id,token) {

       // console.log('mater');
        //console.log(num);
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/commissions/'+id+'/'+num,
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async listCommissionsSelf(num, token) {

        // console.log('mater');
        //console.log(num);
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/commissions/me/' + num,
            headers: {
                authorization: token
            }
        });

        return res.data;
    }


    async sumCommissionsSelf() {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/commissions/me/sum',
            headers: {
                authorization: store.state.currentUser.token
            },
          

        });
        //console.log(res.data);
        return res.data;
    }

    async barchartCommissions(id,token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/commissions/chart/bar/'+id,
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async piechartCommissions(id, token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/commissions/chart/pie/' + id,
            headers: {
                authorization: token
            }
        });

        return res.data;
    }


    async barchartCommissionsSelf(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/commissions/chart/bar/me',
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async piechartCommissionsSelf( token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/commissions/chart/pie/me',
            headers: {
                authorization: token
            }
        });

        return res.data;
    }



}